import axios from '../../axios'

/*
 * 考核员管理模块
 */

/**
 * 导出Excel
 * @param schoolId 驾校ID
 * @param examnum 考核员编号
 * @param name 考核员姓名
 * @param occupationlevel 职业资格等级1:一级2:二级3:三级4:四级
 * @param teachpermitted 准教车型
 * @param  employstatus 供职状态 0:在职； 1:离职
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=702560
 */
export const exportExcel = data => {
  return axios({
    url: '/examiner/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 保存
export const save = (data) => {
    return axios({
        url: '/examiner/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/examiner/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/examiner/list',
        method: 'post',
        data
    })
}
// 分页查询
export const detailView = (data) => {
    return axios({
        url: '/examiner/detail',
        method: 'post',
        data
    })
}
// 获取统一编号
export const handleGetNum = (data) => {
  return axios({
    url: '/examiner/getExaminerNum/' + data,
    method: 'post',
    data
  })
}
// 备案
export const handleRecord = (data) => {
  return axios({
    url: '/examiner/report/' + data,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/examiner/examiner.js